// Este arquivo é gerado automaticamente. Não edite manualmente.

export const translationMap = {
  "en-US": {
    "cookie": "cookie.e322cd6d.json",
    "digest": "digest.ac44fd27.json",
    "errors": "errors.553bf2d1.json",
    "fe": "fe.0b461724.json",
    "labels": "labels.26fca0ab.json",
    "success": "success.74c19321.json",
    "titles": "titles.405938a1.json"
  },
  "pt-BR": {
    "cookie": "cookie.6b90326a.json",
    "digest": "digest.6c9a1fbb.json",
    "errors": "errors.7b6dffc6.json",
    "fe": "fe.e03a5590.json",
    "labels": "labels.199e4ee7.json",
    "success": "success.b1a115db.json",
    "titles": "titles.350f01c3.json"
  }
} as const;
